export default [
  {
    title: 'breadcrumb.dashboard',
    route: 'dashboard',
    icon: 'PieChartIcon',
    resource: 'dashboard',
    action: 'read',
  },
];